import FacebookPage from './views/facebook.page';

export default {
  views:{
    FacebookPage,
  },
};
